(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[915],{

/***/ 6983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.J = void 0;
const recoil_1 = __webpack_require__(53476);
/**
 * Recoil module to persist state to storage
 *
 * @param config Optional configuration object
 * @param config.key Used as key in local storage, defaults to `recoil-persist`
 * @param config.storage Local storage to use, defaults to `localStorage`
 */
const recoilPersist = (config = {}) => {
    if (typeof window === 'undefined') {
        return {
            persistAtom: () => { },
        };
    }
    const { key = 'recoil-persist', storage = localStorage } = config;
    const persistAtom = ({ onSet, node, trigger, setSelf }) => {
        if (trigger === 'get') {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => {
                    if (s.hasOwnProperty(node.key)) {
                        setSelf(s[node.key]);
                    }
                });
            }
            if (state.hasOwnProperty(node.key)) {
                setSelf(state[node.key]);
            }
        }
        onSet(async (newValue) => {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => updateState(newValue, s, node.key));
            }
            else {
                updateState(newValue, state, node.key);
            }
        });
    };
    const updateState = (newValue, state, key) => {
        if (newValue !== null &&
            newValue !== undefined &&
            newValue instanceof recoil_1.DefaultValue &&
            state.hasOwnProperty(key)) {
            delete state[key];
        }
        else {
            state[key] = newValue;
        }
        setState(state);
    };
    const getState = () => {
        const toParse = storage.getItem(key);
        if (toParse === null || toParse === undefined) {
            return {};
        }
        if (typeof toParse === 'string') {
            return parseState(toParse);
        }
        if (typeof toParse.then === 'function') {
            return toParse.then(parseState);
        }
        return {};
    };
    const parseState = (state) => {
        if (state === undefined) {
            return {};
        }
        try {
            return JSON.parse(state);
        }
        catch (e) {
            console.error(e);
            return {};
        }
    };
    const setState = (state) => {
        try {
            if (typeof storage.mergeItem === 'function') {
                storage.mergeItem(key, JSON.stringify(state));
            }
            else {
                storage.setItem(key, JSON.stringify(state));
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    return { persistAtom };
};
exports.J = recoilPersist;


/***/ }),

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 57952:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[doctorId]",
      function () {
        return __webpack_require__(64393);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  margin-top: auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, _textAsH2 = _param.textAsH2, textAsH2 = _textAsH2 === void 0 ? false : _textAsH2, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "textAsH2"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                as: textAsH2 ? "h2" : "span",
                children: text
            })
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-7e5c5516-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    \n    & > span, & > h2 {\n      ").concat(theme.typography.UI18SB, ";\n      color: ").concat(theme.color.white, ";\n    }\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e5c5516-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-7e5c5516-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-7e5c5516-9"
})(_templateObject9());


/***/ }),

/***/ 53157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8202);



var ClickLogger = function(props) {
    var children = props.children, _params = props.params, eventName = _params.eventName, payload = _params.payload, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var log = (0,_hooks_useLogger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().log;
    var child = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var handleLog = function(_e) {
            var evaluatedPayload = typeof payload === "function" ? payload() : payload;
            log({
                eventName: eventName,
                payload: evaluatedPayload
            });
        };
        var wrapper = wrapperRef.current;
        if (wrapper) {
            wrapper.addEventListener("click", handleLog, {
                capture: true
            });
            return function() {
                wrapper.removeEventListener("click", handleLog, {
                    capture: true
                });
            };
        }
    }, [
        eventName,
        payload,
        log,
        enabled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: "contents",
        children: child
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClickLogger);


/***/ }),

/***/ 38245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oy": function() { return /* binding */ useSearchKoreaAddressV2Query; },
/* harmony export */   "Yx": function() { return /* binding */ useDoctorReviewMetricQuery; },
/* harmony export */   "dr": function() { return /* binding */ useGetHospitalByIdQuery; },
/* harmony export */   "hh": function() { return /* binding */ useGetAddressByLocationQuery; },
/* harmony export */   "nR": function() { return /* binding */ useGetTotalReviewCountWithAverageRatingByPublicIdQuery; },
/* harmony export */   "xK": function() { return /* binding */ useGetUserAddressesQuery; }
/* harmony export */ });
/* unused harmony exports GetHospitalByIdDocument, DoctorReviewMetricDocument, GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery, GetTotalReviewCountWithAverageRatingByPublicIdDocument, GetAddressByLocationDocument, GetUserAddressesDocument, SearchKoreaAddressV2Document, HospitalExternalPostDocument, useHospitalExternalPostQuery */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var GetHospitalByIdDocument = "\n    query GetHospitalById($publicId: String!) {\n  getHospitalByPublicId(publicId: $publicId) {\n    id\n    name\n    isBookable\n    isTodayBookable\n    partnershipTemplate\n    profileImages {\n      url\n      isRepresentative\n    }\n    badges\n    naverPlaceDetail {\n      hashtags\n      treatmentMenus {\n        treatmentName\n        price\n      }\n    }\n    temporaryHolidaysNotice\n    temporaryHolidays\n    todayDuty {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n      operatingStatus\n    }\n    duties {\n      dayOfWeek\n      openTime\n      closeTime\n      breakStartTime\n      breakEndTime\n      operationTimes\n      breakTimes\n      isClosed\n    }\n    departmentsV2 {\n      departmentId\n      departmentName\n    }\n    departmentGroups {\n      averageRating\n      departmentGroupId\n      departmentGroupName\n      departmentGroupIconUrl\n      tags\n    }\n    nonBenefitDiagnosisPrices {\n      middleCategoryName\n      minPrice\n      maxPrice\n    }\n    longitude\n    latitude\n    jibunAddress\n    roadAddress\n    detailAddress\n    directionGuidance\n    parkingInformation\n    isFreeParking\n    tel\n    viewCount\n    introduction\n    regionByDepth {\n      siDoName\n      siGunGuName\n      eupMyeonDongName\n    }\n    treatments {\n      id\n      name\n    }\n    hospitalAdBanners {\n      displayDiscount\n      displayPrice\n      id\n      thumbnailImageUrl\n      title\n      url\n      hospitalId\n    }\n    hospitalSurgeries {\n      surgeryCount\n      surgeryName\n      badges\n      id\n    }\n    doctors {\n      id\n      publicId\n      hospitalId\n      isAbsent\n      name\n      displayName\n      medicineType\n      gender\n      profileImagePath\n      contractType\n      departmentGroups {\n        departmentGroupId\n        departmentGroupName\n        departmentGroupIconUrl\n        averageRating\n      }\n      professionalDepartmentsV2 {\n        departmentId\n        departmentName\n        departmentCode\n      }\n      careers {\n        careerType\n        content\n        id\n      }\n      reviewMetric {\n        averageRating\n        totalCount\n        groupByDiagnosisType {\n          count\n          diagnosisType\n          diagnosisTypeId\n          name\n        }\n        groupByRating {\n          count\n          rating\n        }\n      }\n      partnershipStatus\n    }\n    topRatedDoctorReviews(size: 3) {\n      content\n      createdAt\n      id\n      isPrivate\n      likeCount\n      maskedHolderName\n      rating\n      targetCategoryName\n      title\n      isBlocked\n      isLiked\n      comments {\n        content\n        createdAt\n        id\n        isBlocked\n        reviewCommentHolder {\n          id\n          name\n          profileImageUrl\n        }\n      }\n      reviewContext {\n        reviewReceiver {\n          id\n          name\n        }\n      }\n      tags {\n        id\n        reviewId\n        tag {\n          tagId\n          text\n        }\n        tagId\n      }\n    }\n  }\n}\n    ";
var useGetHospitalByIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetHospitalById",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables), options);
};
useGetHospitalByIdQuery.getKey = function(variables) {
    return [
        "GetHospitalById",
        variables
    ];
};
useGetHospitalByIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetHospitalByIdDocument, "GetHospitalById", variables, options);
};
var DoctorReviewMetricDocument = "\n    query DoctorReviewMetric($doctorReviewSearchRequest: DoctorReviewSearchRequestV2Input!) {\n  doctorReviewMetric(doctorReviewSearchRequest: $doctorReviewSearchRequest) {\n    totalCount\n    averageRating\n    groupByRating {\n      count\n      rating\n    }\n    groupByDiagnosisType {\n      diagnosisType\n      diagnosisTypeId\n      name\n      count\n    }\n  }\n}\n    ";
var useDoctorReviewMetricQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "DoctorReviewMetric",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables), options);
};
useDoctorReviewMetricQuery.getKey = function(variables) {
    return [
        "DoctorReviewMetric",
        variables
    ];
};
useDoctorReviewMetricQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DoctorReviewMetricDocument, "DoctorReviewMetric", variables, options);
};
var GetFaceToFaceDiagnosisBookingFormByPublicIdDocument = "\n    query GetFaceToFaceDiagnosisBookingFormByPublicId($publicId: String!) {\n  getFaceToFaceDiagnosisBookingFormByPublicId(publicId: $publicId) {\n    hospital {\n      name\n    }\n    doctor {\n      name\n      medicineType\n    }\n    booking {\n      status\n    }\n    diagnosis {\n      status\n    }\n    bookingId\n    targetDate\n    targetDateDisplayText\n    detailSymptom\n    name\n    registrationNumber\n    address\n    detailAddress\n  }\n}\n    ";
var useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables), options);
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.getKey = function(variables) {
    return [
        "GetFaceToFaceDiagnosisBookingFormByPublicId",
        variables
    ];
};
useGetFaceToFaceDiagnosisBookingFormByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetFaceToFaceDiagnosisBookingFormByPublicIdDocument, "GetFaceToFaceDiagnosisBookingFormByPublicId", variables, options);
};
var GetTotalReviewCountWithAverageRatingByPublicIdDocument = "\n    query GetTotalReviewCountWithAverageRatingByPublicId($publicId: String!) {\n  getTotalReviewCountWithAverageRatingByPublicId(publicId: $publicId) {\n    averageRating\n    totalCount\n  }\n}\n    ";
var useGetTotalReviewCountWithAverageRatingByPublicIdQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables), options);
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey = function(variables) {
    return [
        "GetTotalReviewCountWithAverageRatingByPublicId",
        variables
    ];
};
useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetTotalReviewCountWithAverageRatingByPublicIdDocument, "GetTotalReviewCountWithAverageRatingByPublicId", variables, options);
};
var GetAddressByLocationDocument = "\n    query GetAddressByLocation($longitude: Float!, $latitude: Float!) {\n  getAddressByLocation(longitude: $longitude, latitude: $latitude) {\n    detailAddress\n    jibunAddress\n    roadAddress\n    sido\n    zipCode\n    sigungu\n    dongLi\n  }\n}\n    ";
var useGetAddressByLocationQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetAddressByLocation",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables), options);
};
useGetAddressByLocationQuery.getKey = function(variables) {
    return [
        "GetAddressByLocation",
        variables
    ];
};
useGetAddressByLocationQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetAddressByLocationDocument, "GetAddressByLocation", variables, options);
};
var GetUserAddressesDocument = "\n    query GetUserAddresses {\n  getUserAddresses {\n    userAddressId\n    userId\n    alias\n    roadAddress\n    oldAddress\n    detailAddress\n    addressType\n    location {\n      latitude\n      longitude\n    }\n    zipCode\n    deliveryComment\n    frontDoorPassword\n    isDefault\n  }\n}\n    ";
var useGetUserAddressesQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables), options);
};
useGetUserAddressesQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetUserAddresses"
    ] : [
        "GetUserAddresses",
        variables
    ];
};
useGetUserAddressesQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetUserAddressesDocument, "GetUserAddresses", variables, options);
};
var SearchKoreaAddressV2Document = "\n    query SearchKoreaAddressV2($request: KoreaAddressSearchRequestV2Input!) {\n  searchKoreaAddressV2(request: $request) {\n    centroidLatitude\n    centroidLongitude\n    displayName\n    regionCode\n    regionName\n  }\n}\n    ";
var useSearchKoreaAddressV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchKoreaAddressV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables), options);
};
useSearchKoreaAddressV2Query.getKey = function(variables) {
    return [
        "SearchKoreaAddressV2",
        variables
    ];
};
useSearchKoreaAddressV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchKoreaAddressV2Document, "SearchKoreaAddressV2", variables, options);
};
var HospitalExternalPostDocument = "\n    query HospitalExternalPost($hospitalPublicId: ID!, $size: Int!, $pivotId: Int) {\n  hospitalExternalPost(\n    hospitalPublicId: $hospitalPublicId\n    size: $size\n    pivotId: $pivotId\n  ) {\n    totalCount\n    items {\n      id\n      title\n      content\n      postedAt\n      url\n    }\n  }\n}\n    ";
var useHospitalExternalPostQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "HospitalExternalPost",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables), options);
};
useHospitalExternalPostQuery.getKey = function(variables) {
    return [
        "HospitalExternalPost",
        variables
    ];
};
useHospitalExternalPostQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(HospitalExternalPostDocument, "HospitalExternalPost", variables, options);
};


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ Review; },
/* harmony export */   "Fj": function() { return /* binding */ EReviewType; },
/* harmony export */   "IE": function() { return /* binding */ ReviewComment; },
/* harmony export */   "R": function() { return /* binding */ ReviewDiagnosisDoctor; },
/* harmony export */   "Vj": function() { return /* binding */ ReviewTag; },
/* harmony export */   "XV": function() { return /* binding */ ReviewTagExposure; },
/* harmony export */   "fr": function() { return /* binding */ ReviewTargetType; }
/* harmony export */ });
/* unused harmony exports MedicineType, ReviewDiagnosis */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27805);


var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["DOCTOR"] = "DOCTOR";
    ReviewTargetType["PHARMACY"] = "PHARMACY";
})(ReviewTargetType || (ReviewTargetType = {}));
var EReviewType;
(function(EReviewType) {
    EReviewType["NORMAL"] = "NORMAL";
    EReviewType["BEST"] = "BEST";
})(EReviewType || (EReviewType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var Review = /*#__PURE__*/ function() {
    "use strict";
    function Review(review) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Review);
        this.review = review;
    }
    var _proto = Review.prototype;
    _proto.shouldNotDisplayed = function shouldNotDisplayed(currentUserId) {
        if (!this.isPrivate) {
            return false;
        }
        return Number(currentUserId) !== Number(this.userId);
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Review, [
        {
            key: "id",
            get: function get() {
                return this.review.id;
            }
        },
        {
            key: "isPrivate",
            get: function get() {
                return this.review.isPrivate;
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.review.userId;
            }
        },
        {
            key: "isLiked",
            get: function get() {
                return this.review.isLiked;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.review.title;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.review.content;
            }
        },
        {
            key: "writer",
            get: function get() {
                return this.review.writer;
            }
        },
        {
            key: "rating",
            get: function get() {
                return this.review.rating;
            }
        },
        {
            key: "comment",
            get: function get() {
                return this.review.comment;
            }
        },
        {
            key: "likeCount",
            get: function get() {
                return this.review.likeCount;
            }
        },
        {
            key: "tags",
            get: function get() {
                return this.review.tags;
            }
        },
        {
            key: "price",
            get: function get() {
                return this.review.price;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.review.createdAt;
            }
        },
        {
            key: "diagnosisCategoryName",
            get: function get() {
                return this.review.diagnosisCategoryName;
            }
        },
        {
            key: "doctor",
            get: function get() {
                return this.review.doctor;
            }
        }
    ]);
    return Review;
}();
var ReviewTag = /*#__PURE__*/ function() {
    "use strict";
    function ReviewTag(tag) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewTag);
        this.tag = tag;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewTag, [
        {
            key: "reviewId",
            get: function get() {
                return this.tag.reviewId;
            }
        },
        {
            key: "tagId",
            get: function get() {
                return this.tag.tagId;
            }
        },
        {
            key: "text",
            get: function get() {
                return this.tag.text;
            }
        }
    ]);
    return ReviewTag;
}();
var ReviewComment = /*#__PURE__*/ function() {
    "use strict";
    function ReviewComment(reviewComment) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewComment);
        this.reviewComment = reviewComment;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewComment, [
        {
            key: "createdAt",
            get: function get() {
                return this.reviewComment.createdAt;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.reviewComment.content;
            }
        }
    ]);
    return ReviewComment;
}();
var ReviewDiagnosis = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ReviewDiagnosis(reviewDiagnosis) {
        _class_call_check(this, ReviewDiagnosis);
        this.reviewDiagnosis = reviewDiagnosis;
    }
    _create_class(ReviewDiagnosis, [
        {
            key: "doctor",
            get: function get() {
                return this.reviewDiagnosis.doctor;
            }
        }
    ]);
    return ReviewDiagnosis;
}()));
var ReviewDiagnosisDoctor = /*#__PURE__*/ function() {
    "use strict";
    function ReviewDiagnosisDoctor(reviewDiagnosisDoctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewDiagnosisDoctor);
        this.reviewDiagnosisDoctor = reviewDiagnosisDoctor;
    }
    var _proto = ReviewDiagnosisDoctor.prototype;
    _proto.getDoctorDisplayName = function getDoctorDisplayName() {
        if (this.medicineType === MedicineType.OrientalDoctor) {
            return "".concat(this.name, " 한의사");
        }
        return "".concat(this.name, " 의사");
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewDiagnosisDoctor, [
        {
            key: "id",
            get: function get() {
                return this.reviewDiagnosisDoctor.id;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.reviewDiagnosisDoctor.medicineType;
            }
        },
        {
            key: "name",
            get: function get() {
                return this.reviewDiagnosisDoctor.name;
            }
        },
        {
            key: "profile",
            get: function get() {
                return this.reviewDiagnosisDoctor.profile;
            }
        }
    ]);
    return ReviewDiagnosisDoctor;
}();
var ReviewTagExposure;
(function(ReviewTagExposure) {
    ReviewTagExposure["ALWAYS"] = "ALWAYS";
    ReviewTagExposure["POSITIVE"] = "POSITIVE";
    ReviewTagExposure["NEGATIVE"] = "NEGATIVE";
    ReviewTagExposure["NONE"] = "NONE";
})(ReviewTagExposure || (ReviewTagExposure = {}));


/***/ }),

/***/ 64393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83651);
/* harmony import */ var _views_doctor_detail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98406);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55351);
// PageDescription: 의사 상세 페이지




var DoctorDetailPage = function(param) {
    var client = param.client, seoData = param.seoData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            seoData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: seoData.title,
                description: seoData.description,
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: seoData.keywords
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_doctor_detail__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDetailTemplate */ .kk, {
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (DoctorDetailPage);
DoctorDetailPage.Layout = _components_layouts_DefaultLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53476);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89430);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9653,7292,5679,5179,9922,7417,6409,7966,9939,6874,9774,2888,179], function() { return __webpack_exec__(57952); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);